import { Component } from '@angular/core';
import { BreakpointService } from '@herrenknecht-connected/angular-shared-utils-core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { NotificationsOverlayService } from './notifications-overlay.service';
import { AppFrameService } from './app-frame.service';

@UntilDestroy()
@Component({
  template: `
    <div data-testid="hk-connected-logo.button" class="flex flex-initial items-center justify-start">
      <img src="media/shared/logo-connected.svg" class="ml-2 h-[50px] w-[140px] p-1 max-md:hidden" alt="HK Connected Logo" />
      <img
        src="media/shared/small-logo-connected.svg"
        class="h-[50px] w-[40px] animate-pulse-slow p-1 md:hidden"
        alt="HK Connected Logo"
        (click)="menu.toggleSidenav()"
        data-testid="hk-connected-logo"
      />
    </div>
    <div class="flex flex-1 items-center justify-center">
      <ng-content select="[hkTopBarLeft]"></ng-content>
    </div>
    <div class="flex flex-initial items-center justify-end gap-1">
      <ng-container *ngIf="numberNotifications > 0">
        <button
          data-testid="topBar.toggleNotifications.button"
          hk-button-flat
          [matBadge]="numberUnseenNotifications"
          [matBadgeHidden]="!numberUnseenNotifications"
          matBadgeSize="small"
          [disabled]="!numberNotifications"
          (click)="toggleNotifications($event)"
          class="mr-3 max-lg:!hidden lg:!flex"
        >
          <hk-icon-with-label iconClass="ph ph-bell" text="{{ 'notifications.title' | translate }}"></hk-icon-with-label>
        </button>
        <button
          data-testid="topBar.toggleNotifications.button"
          class="lg:!hidden"
          hk-button-flat
          [matBadge]="numberUnseenNotifications"
          [matBadgeHidden]="!numberUnseenNotifications"
          matBadgeSize="small"
          [disabled]="!numberNotifications"
          (click)="toggleNotifications($event)"
        >
          <i class="ph ph-bell"></i>
        </button>
      </ng-container>
      <ng-content select="[hkTopBarRight]"></ng-content>
    </div>
    <!--    </div>-->
  `,
  host: { class: 'flex flex-none h-[50px] items-center justify-between border-b border-hk_gray-200 pr-6' },
  selector: 'hk-top-bar',
})
export class TopBarComponent {
  public numberUnseenNotifications = 0;
  public numberNotifications = 0;

  private _isNotificationsOpen = false;

  public constructor(
    private logger: NGXLogger,
    private _notificationsOverlay: NotificationsOverlayService,
    public breakpoints: BreakpointService,
    public menu: AppFrameService,
    public translate: TranslateService,
  ) {
    this.menu.sidenavVisible$.pipe(untilDestroyed(this)).subscribe({
      next: (isSidenav) => this.logger.info(`sidenav ${isSidenav}`),
    });
    this.menu.notifications$.pipe(untilDestroyed(this)).subscribe({
      next: (notifications) => {
        this.numberUnseenNotifications = notifications.filter((n) => !n._seen).length;
        this.numberNotifications = notifications.length;
      },
    });
  }

  toggleNotifications(event: MouseEvent) {
    if (!this._isNotificationsOpen) {
      const target = this.breakpoints.md
        ? event.currentTarget
        : (event.currentTarget as HTMLElement)?.parentElement?.parentElement?.parentElement;
      this._notificationsOverlay.open(target as HTMLElement, {
        onClose: () => {
          this._isNotificationsOpen = false;
        },
      });
      this._isNotificationsOpen = true;
    }
  }
}
